"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  DOMAIN_INVALID: null,
  TARGET_PAGE_ERROR: null,
  WEBSITE_GRADER_ERROR: null
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/ErrorTypes.js
// module id = 245
// module chunks = 0